import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const workorderEmployeeColumn: GridColumnConfig[] = [
  {
    title: 'Worked On',
    field: 'workedOn',
    filter: 'text',

    //   editable: true,
    editor: 'date',
    isDecimal: true,
  },
  {
    title: 'Employee Name',
    field: 'employeeName',
    filter: 'text',

    //   editable: true,
    editor: 'text',
    isDecimal: true,
  },
  {
    title: 'Worked Hours',
    field: 'workedHours',
    filter: 'text',
    //   fieldType: 'currency',
    //   editable: true,
    width: '140',
    editor: 'textHour',
    isDecimal: true,
  },

  {
    title: 'Option',
    field: 'option',
    filter: 'text',
    width: '140',
  },
];
